var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"datatable-page-info"},[_vm._v(" "+_vm._s(_vm.from)+"-"+_vm._s(_vm.to)+" sur "+_vm._s(_vm.totalCount)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }